import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import ResolvedReason from '../ResolvedReason';
import CPEBanner from '../Vulnerability/CPEBanner';
import Dependency from '../Vulnerability/Dependency';
import Description from '../Vulnerability/Description';
import Details from '../Vulnerability/Details';
import Footer from '../Vulnerability/Footer';
import Header from '../Vulnerability/Header';
import NVDBaseMetrics from '../Vulnerability/NVDBaseMetrics';
import References from '../Vulnerability/References';
import Remediation from '../Vulnerability/Remediation';
import type { IssueDetailsTab } from '../Tabs';

import IssueGenericContent from './IssueGenericContent';
import VulnerabilityIssueLoading from './Loading/VulnerabilityIssueLoading';

type VulnerabilityIssueDrawerContentProps = {
  activeTab: IssueDetailsTab;
  setActiveTab: (tab: IssueDetailsTab) => void;
};

const VulnerabilityIssueContent: VoidFunctionComponent<VulnerabilityIssueDrawerContentProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const isLoadingIssueDetails = useSelector(IssuesV2Store.selectors.getIsLoadingIssueDetails);

  if (isLoadingIssueDetails) {
    return <VulnerabilityIssueLoading />;
  }

  return (
    <IssueGenericContent
      headerSlot={<Header />}
      contentSlot={
        <>
          <CPEBanner />
          <ResolvedReason />
          <Remediation />
          <Details />
          <Dependency />
          <Description />
          <NVDBaseMetrics />
          <References />
          <Footer />
        </>
      }
      setActiveTab={setActiveTab}
      activeTab={activeTab}
    />
  );
};

export default VulnerabilityIssueContent;
